import React, { memo } from "react";
import { lighten, darken } from "@mui/material/styles";
import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import Iconify from "../../components/Iconify";

const AssessmentCourseCard = memo(
  ({
    name,
    color,
    admissionNotTaken,
    clickFunction,
    delay = 0,
    userId,
    course_name,
  }) => {
    const GradientCard = styled(motion.div)(({ color, theme }) => ({
      background: `linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))`,
      color: theme.palette.getContrastText(lighten(color, 0.1)),
      padding: "24px",
      // height: theme.spacing(20),
      borderRadius: "12px",
      // boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "6px 6px 4px 0 black",
      },
    }));

    const NameWrapperStyle = styled(Box)(({ color }) => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20px",
      paddingTop: "5px",
      paddingLeft: "10px",
      paddingRight: "10px",
      marginBottom: "16px",
      background: "white",
      Width: "auto",
      height: "40px",
      // border:'1px solid white'
    }));
    const CountWrapperStyle = styled(Box)(({ color }) => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20px",
      paddingRight: "5px",
      paddingLeft: "5px",
      background: "white",
      width: "auto",
      // border:'1px solid white'
    }));

    const IconWrapper = styled(Box)(({ color }) => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20px",
      padding: "5px",
      marginBottom: "16px",
      background: "white",
      height: "40px",
      width: "40px",
      // border:'1px solid white'
    }));

    const TitleTypography = styled(Typography)(({ theme }) => ({
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      marginBottom: theme.spacing(1),
      color: "#7054eb",
    }));

    return (
      <GradientCard
        initial={{ y: -200, x: 0, opacity: 0 }} // Start higher and slightly offset horizontally
        animate={{ y: 0, x: 0, opacity: 1 }} // Drop to original position
        transition={{ duration: 0.5, delay }} // Smooth transition with delay
        color={color}
        onClick={() => clickFunction(userId, course_name)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <IconWrapper>
            <Iconify
              icon={"mdi:academic-cap"}
              color="#7054eb"
              width={30}
              height={30}
            />
          </IconWrapper>
          <NameWrapperStyle color={color}>
            <TitleTypography>{name}</TitleTypography>
          </NameWrapperStyle>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography>Non Enrolled</Typography>
          <CountWrapperStyle>
            <Typography
              sx={{
                color: "#7054eb",
                fontSize: 15,
                fontWeight: 700,
              }}
            >
              {admissionNotTaken}
            </Typography>
          </CountWrapperStyle>
        </Box>
      </GradientCard>
    );
  }
);

export default AssessmentCourseCard;
